import { useQuery } from '@tanstack/react-query';

import { getData } from 'services/api';
import { OrdersData } from 'features/PunchupPages/Orders/types';

import { RecentComp } from '../types';

export const RECENT_COMPS_LIMIT = 8;

const ALL_TIME = 'all_time';

// Keyed under the ['orders'] prefix on purpose: invalidateAfterSend refetches it, so a send on this
// page refreshes the card without the page arranging it. /orders is already ordered newest-first.
export const useRecentComps = (eventId: string) => {
	const params = new URLSearchParams({
		date: ALL_TIME,
		comped: 'true',
		event_ids: eventId,
		page: '1',
		per_page: String(RECENT_COMPS_LIMIT),
	});

	return useQuery({
		queryKey: ['orders', 'recentComps', eventId],
		queryFn: () => getData(`/orders?${params.toString()}`),
		enabled: !!eventId,
		select: (response: { data?: OrdersData[] }): RecentComp[] =>
			(response?.data ?? []).map((order) => ({
				transactionId: order.id,
				name: order.User?.full_name ?? '',
				email: order.User?.email ?? '',
				quantity: order.quantity,
				ticketTypeNames: order.tickets_name ?? [],
				sentAt: order.date_time,
			})),
	});
};
